import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-receipts-details',
  templateUrl: './receipts-details.component.html',
  styleUrls: ['./receipts-details.component.css']
})
export class ReceiptsDetailsComponent implements OnInit {

  constructor(private receiptService:ServiceService,private route: ActivatedRoute, private router: Router)
  { }


  //------function for routing to invoice details-------------------------

  InvoiceDetails(){
    this.router.navigateByUrl(('admin/invoice-detail'));
    document.body.scrollTop = document.documentElement.scrollTop = 0;   
  }
  
  //--------function which give name of selected invoices--------
  getValue = (item : string) =>{
     
    this.receiptService.setInvoiceId(item)
    console.log("id=",item)
  
  }
   
  output:any=[]; //---store get() result--------
  receiptId='';
 // getUrl='http://192.241.151.66:5000/viewReceipts';
  receipt_value=''
  //-------date formating-------------
  today: Date = new Date();
  pipe = new DatePipe('en-US');
  DateAndTime:any= null;
  ClearingDate:any=null;
  number=""

   //------routing to edit page--------------------
    
   EditReceipts(){
    this.router.navigateByUrl(('admin/edit-product'));  
    console.log("call edit product")
  }
  
  ngOnInit(): void {

    //---call function in service for receipt Id------
    this.receiptId=this.receiptService.getReceiptId()

    //-------api get()calling-------------
    this.receiptService.ReceiptById('/'+this.receiptId).subscribe((res)=>{
      this.output=res.data
      this.receipt_value=res.total_receipts_value
      this.number=this.output[0].receipt_number
      //-------date formating----------------------
     this.DateAndTime = this.pipe.transform(this.output[0].date_time, 'MMM d, y, h:mm:ss a');
     this.ClearingDate= this.pipe.transform(this.output[0].clearing_date, 'MMM d, y, h:mm:ss a');
      console.log("productDetail =",this.output)

    })

   
  }

}
